import { ResourceIdentifierModel } from '../../abstract/domain/ResourceIdentifierModel';

export class ResourceIdentifier implements ResourceIdentifierModel {
  public readonly resourceIdentifier: string = '';
  public readonly queryParams: URLSearchParams | undefined = undefined;

  protected constructor(
    private readonly identifier: string,
    private readonly params?: Record<string, string>,
  ) {
    const queryParams: Record<string, string> = params || {};

    this.resourceIdentifier = identifier;
    this.queryParams = !!Object.entries(queryParams).length
      ? new URLSearchParams(Object.entries(queryParams))
      : undefined;
  }

  public static create(
    resourceIdentifier: string,
    queryParams?: Record<string, string>,
  ): ResourceIdentifier {
    return new ResourceIdentifier(resourceIdentifier, queryParams);
  }
}
